import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import useWindowSize from "../../hooks/useWindowSize";

const UserModal = React.forwardRef(({ item }, ref) => {
  const { width } = useWindowSize();

  const truncatedText = (text, noOfChar) => {
    if (text.length <= noOfChar) {
      return text;
    } else {
      const res = text.slice(0, noOfChar) + "...";
      return res;
    }
  };

  const postBody = (
    <div className="flex w-full justify-start">
      <div className="relative mr-8 w-[10%]">
        {item?.user_details?.profile_image ? (
          <div className="w-full">
            <div className="my-2 ml-2 h-[48px] w-[48px]">
              <img
                src={item?.user_details?.profile_image}
                alt="profile image"
                height="40"
                width="40"
                className="object-fit h-full w-full rounded-full"
              />
            </div>
            {item?.user_details?.linkedin_url ? (
              <button
                className="absolute top-[35px] left-9"
                onClick={() => {
                  window.open(item?.user_details?.linkedin_url, "_blank");
                }}
              >
                <div className="h-[23px] w-[23px]">
                  <img
                    src={
                      "https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                    }
                    alt="linkedin icon"
                    className="h-full w-full object-cover"
                  />
                </div>
              </button>
            ) : null}
          </div>
        ) : (
          <div className="w-full">
            <div className="my-2 ml-2 h-[48px] w-[48px] rounded-full">
              <FontAwesomeIcon
                className="text-[48px] text-slate-600"
                icon={faUserCircle}
              />
            </div>
            {item?.user_details?.linkedin_url ? (
              <button
                className="absolute top-[35px] left-9"
                onClick={() => {
                  window.open(item?.user_details?.linkedin_url, "_blank");
                }}
              >
                <div className="h-[23px] w-[23px]">
                  <img
                    src={
                      "https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                    }
                    alt="linkedIn icon"
                    className="h-full w-full object-cover"
                  />
                </div>
              </button>
            ) : null}
          </div>
        )}
      </div>
      <div className="mr-1 flex w-[39%] flex-col items-start justify-center">
        <p className="w-full truncate text-left text-sm font-bold">
          {item?.user_details?.name}
        </p>
        <p className="w-full truncate text-left text-xs font-medium text-[#818181]">
          {item?.job_designation}
        </p>
      </div>
      <div className="mx-1 flex w-[40%] items-center justify-start">
        <div className="mr-2 h-[35px] w-[35px]">
          <img
            src={item?.company_details?.company_image?.url}
            alt="Company Name"
            className="h-full w-full object-cover"
          />
        </div>
        <p className="flex-1 text-left text-xs font-medium leading-tight text-[#818181]">
          {item?.company_details?.company_name
            ? width < 768
              ? truncatedText(item?.company_details?.company_name, 25)
              : width < 1024
              ? truncatedText(item?.company_details?.company_name, 30)
              : item?.company_details?.company_name
            : null}
        </p>
      </div>
    </div>
  );

  const content = ref ? (
    <div ref={ref} className="w-full rounded-lg border-2 border-[#086788]">
      {postBody}
    </div>
  ) : (
    <div className="w-full  rounded-lg border-2 border-[#086788]">
      {postBody}
    </div>
  );

  return content;
});

export default UserModal;
